import './index.scss'

$(document).scroll(function () {
  let scroH = $(document).scrollTop(); //滚动高度
  let viewH = $(window).height(); //可见高度

  // banner位移效果
  $('.section1 .bg').css({
    'transform':'translateY('+ scroH / 3 +'px)'
  })
})

$(document).ready(function(){

  let paddingLeft = $('.section2').css("padding-left")
  let navLeft = $('.section2 .cont a.active').offset().left - parseInt(paddingLeft.replace('px', ''))
  $('.section2 .cont').scrollLeft(navLeft)

  $('.section3 .shop-list ul li').hover(function(){
    if($(this).find('video').length > 0 && $(window).width()>1024){
      $(this).find('video')[0].play()
    }
  },function(){
    if($(this).find('video').length > 0 && $(window).width()>1024){
      $(this).find('video')[0].pause()
    }
  })

})
